import { createGlobalStyle, css } from "styled-components";

import heading from "./heading";
import link from "./link";
import button from "./button";
import { font } from "./font";

export default createGlobalStyle`
    ${heading}
    ${link}
    ${button}
    ${font}
    body {
        margin: 0;
        padding: 0;
        font-family: "Source Sans Pro", sans-serif;
        background-color: ${p => p.theme.mode === "dark" ? "#353b46" : p.theme.c.disabled};
        overflow-y: scroll;
        overflow-x: hidden;
        color: ${p => p.theme.mode === "dark" ? p.theme.c.light : p.theme.c.dark};
        transition: padding-top 500ms;

        *::selection {
            background: ${p => p.theme.c.pale};
        }

        &.modal-open {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow-y: hidden;
        }
    }
    
    input, textarea, button {
        font-family: inherit;
        color: inherit;
    }

    button {
        color: ${p => p.theme.c.dark};

        &::-moz-focus-inner {
            border: 0;
        }
    }

    
    img {
        user-select: none;
    }
    * {
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
    }
    a {
        text-decoration: none;
        color: inherit;

        outline: 0;
    }


    .spring--padding {
        padding: 0 20px;
    }

    .spring--shadow {
        box-shadow: 1px 0 12px 4px rgba(0, 0, 0, 0.2);
    }

    .hide-xs {
        ${p =>
            p.theme.xs(css`
                display: none;
            `)}
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        /* stylelint-disable */
        -webkit-appearance: none;
        margin: 0;
        /* stylelint-enable */
    }

    input[type="number"] {
        /* stylelint-disable */
        -moz-appearance: textfield;
        /* stylelint-enable */
    }
`;
